<template>
  <div class="page-contact">
    <tabbed-view :tabs="getTabs()"/>
  </div>
</template>

<script>
import TabbedView from '@/views/components/tabs/TabbedView';
import PageTitle from "@/views/components/extra-components/layout/PageTitle";
import { mapGetters } from 'vuex';

export default {
  name: "Contact",
  components: {
    TabbedView,
    PageTitle,
  },
  computed: {
    ...mapGetters({
      isDeleted: 'getIsDeleted'
    })
  },
  methods: {
    getTabs() {
      return [
        {
          label: 'Details',
          route: 'contact.view',
        },
        {
          label: 'Addresses',
          route: 'contact.addresses.list',
          hideIfDeleted: this.isDeleted,
        },
        {
          label: 'Beneficiaries',
          route: 'contact.beneficiaries.view',
          hideIfDeleted: this.isDeleted,
        },
        {
          label: 'Distribution Lists',
          route: 'contact.distribution-list.list',
          hideIfDeleted: this.isDeleted,
        },
      ]
    },
  },
}
</script>
